import { Blue80, Button } from '@traceair/tds';
import React from 'react';
import { stylesheet } from 'typestyle';
import { trackAction } from '../../../../../../libs/analytics/ActionTracking';
import { Customer, Site } from '../../../../../../types';
import { DownloadIcon } from '@traceair/webapp-icons';

// Under the map (not on it), so the map credit in its bottom corner stays visible and clickable;
// looks like the Existing GCPs button below it. Block-level, so the two buttons do not share a line and widen
// the column past the map
const css = stylesheet({
  button: {
    marginTop: 8,
    display: 'flex',
  },
});

interface Props {
  customer: Customer;
  site: Site;
}

export const CheckFlightAreaButton = ({ customer, site }: Props) => {
  const handleClick = () => {
    trackAction('Click to download flight plan button', { customer, site });
    window.open(BackofficeUrl + `/#/customers/${customer.id}/sites/${site.id}/export-area`);
  };

  return (
    <Button
      icon={<DownloadIcon color={Blue80} />}
      className={css.button}
      onClick={handleClick}
      text="Flight Area KML"
      style="secondary"
      fullWidth
      size="xs"
    />
  );
};
